export enum VideoPlayerEventType {
  LOAD_START = 'loadstart',
  WAITING = 'waiting',
  PLAY = 'play',
  PLAYING = 'playing',
  PAUSE = 'pause',
  ERROR = 'error',
  LOADED_DATA = 'loadeddata',
  LOADED_METADATA = 'loadedmetadata',
  ENDED = 'ended',
  SEEKED = 'seeked'
}
